import script from "./Calender.vue?vue&type=script&setup=true&lang=ts"
export * from "./Calender.vue?vue&type=script&setup=true&lang=ts"

import "./Calender.vue?vue&type=style&index=0&id=71e20a02&lang=css"

const __exports__ = script;

export default __exports__